module.exports = __webpack_public_path__ + "img/no-image.3708994b.jpg";